import React from 'react';
import { Hanger, IconButton } from '@economic/gaudi';
import { useCurrentAgreement } from '@economic/react-app';
import ExternalLink from '../../shared/components/ExternalLink';
import { t, tBB } from '../../shared/components/l10n/l10n';
import { InboxHanger, useInboxHanger } from './useInboxHanger';

export function InboxIconButton(props) {
    const agreement = useCurrentAgreement();
    const hasSmartInbox = agreement.modules.smartInbox;
    const hasSmartInboxTrial = hasSmartInbox && agreement.features.smartInboxTrialHanger;
    const inboxTooltip = hasSmartInbox ? t`HEADER_TAB_SMARTINBOX` : t`HEADER_TAB_INBOX`;
    const [showHanger, hideHanger] = useInboxHanger(InboxHanger.Inbox);
    const [showTrialHanger, hideTrialHanger] = useInboxHanger(InboxHanger.SmartInboxTrial);

    const hangerType = hasSmartInboxTrial ? InboxHanger.SmartInboxTrial : hasSmartInbox ? InboxHanger.Inbox : undefined;

    const getHangerAttributes = (hangerType?: InboxHanger) => {
        if (hangerType === InboxHanger.Inbox) {
            return {
                content: t`HANGER_INBOX`,
                hide: hideHanger,
                visible: showHanger,
            };
        }

        if (hangerType === InboxHanger.SmartInboxTrial) {
            return {
                content: (
                    <>
                        <div className="text-lg font-bold mb-2">{t`HANGER_SECONDARYNAVIGATION_INBOX_SMARTINBOXTRIAL2021AUTUMN_HEADLINE`}</div>
                        {tBB('HANGER_SECONDARYNAVIGATION_INBOX_SMARTINBOXTRIAL2021AUTUMN_TEXT', {
                            __LINK: content => (
                                <ExternalLink href="https://www.e-conomic.dk/lpd/gratis-smartinbox">{content}</ExternalLink>
                            ),
                        })}
                    </>
                ),
                hide: hideTrialHanger,
                visible: showTrialHanger,
            };
        }

        return undefined;
    };

    const inboxButton = <IconButton {...props} icon="inbox" aria-label="Inbox" tooltip={inboxTooltip} />;

    const hangerAttributes = getHangerAttributes(hangerType);
    if (!hangerAttributes || !hangerAttributes.visible) {
        return inboxButton;
    }

    return (
        <Hanger disclosure={inboxButton} placement="bottom" aria-label="Hanger" onClose={hangerAttributes.hide}>
            {hangerAttributes.content}
        </Hanger>
    );
}
